import { LocaleClub } from '../en/club'

const club: LocaleClub = {
  clubPosts: 'Posts del club',
  clubs: 'Clubes',
  myClubs: 'Mis clubes',
  exploreClubs: 'Explorar clubes',
  requested: 'Solicitado:',
  invited: 'Invitado:',
  joinClub: 'Unirse al Club',
  leaveClub: 'Salir del Club',
  requestPending: 'Solicitud Pendiente',
  invitation: 'Invitación',
  invitationDesc: 'Estás siendo invitado por el director del club, ¿deseas ser parte de este club?',
  acceptInvitation: 'Ahora eres miembro del club invitado.',
  declineInvitation: 'Has declinado convertirte en miembro del club invitado.',
  editClub: 'Editar Club',
  fixClubPayments: 'Resolver problemas de la cuenta de pagos del club.',
  setUpYourClubPayments: 'Configurar los pagos del club para crear un evento.',
  about: 'Acerca de',
  clubDetails: 'Detalles del Club',
  clubContact: 'Contacto del Club',
  clubAbout: 'Acerca del Club',
  directors: 'Directores',
  organizers: 'Organizadores',
  invitePlayers: 'Invitar Jugador(es)',
  importPlayersCSV: 'Importar Jugadores mediante CSV',
  removeMember: 'Eliminar miembro',
  removeMemberDesc: 'Este miembro será eliminado del club.',
  playerAddedSuccess: 'Jugadores añadidos exitosamente',
  importPlayers: 'Importar Jugadores',
  importMatchesCSV: 'Importar Partidos mediante CSV',
  importMatches: 'Importar Partidos',
  createNewEvent: 'Crear Nuevo Evento',
  eventDetails: 'Detalles del Evento',
  addOrganizers: 'Añadir Organizadores',
  clubOrganizers: 'Los Organizadores del Club deben tener una cuenta DUPR para ser agregados a tu club.',
  clubPlayers: 'Los Jugadores del Club deben tener una cuenta DUPR para ser agregados a tu club.',
  addOrganizer: 'Añadir Organizador',
  addMember: 'Añadir Miembro(s)',
  inviteAPLayer: 'Invitar a un Jugador',
  inviteAPLayerDesc:
    'El jugador invitado debe crear una cuenta con el correo electrónico ingresado a continuación antes de que los resultados del partido puedan ser validados.',
  clubName: 'Nombre del Club',
  removeOrganizerTitle: 'Eliminar organizador del club',
  removeOrganizerText: '¿Eliminar organizadora del club?',
  removeOrganizer: 'Confirmar',
  createEventDesc:
    'La siembra y el registro no están disponibles ya que actualmente estamos trabajando en conectarte con nuestros socios de API.',
  seedMatchesDesc:
    'La siembra ya no está disponible. Queremos promocionar a nuestros socios de API de Gestión de Eventos; en el botón [Registrarse] ahora puedes pegar la URL de tu evento desde otros softwares.',
  leaveDUPRWarning:
    'Serás redirigido a la página de registro y dejarás esta página de DUPR al hacer clic en este botón.',
  clubsNearMe: 'Clubes Cerca de Mí',
}

export default club
